import React, { FC, memo, useCallback, useContext, useMemo, useState } from 'react'

import { FilterContainer } from './styles'
import FilterContent from './content'
import FilterHeader from './header'
import { FilterHeadPosition, FilterType } from '../types'
import { FilterTransport } from '../../../../transports/filters-configuration-transport'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import { ScreenContext } from 'react-components'

type Props = {
    filter: FilterTransport
    filterHeadPosition: FilterHeadPosition
    filterStaticData: FilterSectionTransport
}

const _generateSelectedFiltersList = (filter: FilterTransport) => {
    const selectedFilters = ''
    if (filter.items && filter.items.length > 0) {
        switch (filter.type) {
            case FilterType.PRICES: {
                return {
                    isFilterSelected:
                        filter.items[0].selectedMin !== filter.items[0].minPrice ||
                        filter.items[0].selectedMax !== filter.items[0].maxPrice,
                }
            }
            case FilterType.CANCELLATION_POLICY: {
                return {
                    isFilterSelected: filter.items[0].checked,
                }
            }

            default: {
                filter.items.forEach(item => {
                    if (item.checked) {
                        return {
                            isFilterSelected: true,
                        }
                    }
                })
            }
        }
    }
    return { isFilterSelected: !!selectedFilters }
}

const Filter: FC<Props> = ({ filter, filterHeadPosition, filterStaticData }) => {
    const { isMobile, isTablet } = useContext(ScreenContext)
    const [isFilterSelected] = useMemo(() => {
        const generatedSelectedFiltersList = _generateSelectedFiltersList(filter)

        return [generatedSelectedFiltersList.isFilterSelected]
    }, [filter, filterHeadPosition, isMobile, isTablet])

    const [isOpen, setIsOpen] = useState(true)

    const handleToggle = useCallback(() => {
        setIsOpen(prev => !prev)
    }, [])

    return (
        <FilterContainer filterHeadPosition={filterHeadPosition}>
            <FilterHeader
                filterTitle={filter.title}
                filterType={filter.type}
                filterHeadPosition={filterHeadPosition}
                isFilterSelected={isFilterSelected}
                newTag={filter.type === FilterType.CANCELLATION_POLICY}
                isActive={isOpen}
                onToggle={handleToggle}
            />
            {isOpen && (
                <FilterContent
                    filterType={filter.type}
                    filter={filter}
                    filterHeadPosition={filterHeadPosition}
                    filterStaticData={filterStaticData}
                    isFilterSelected={isFilterSelected}
                />
            )}
        </FilterContainer>
    )
}

export default memo(Filter)
